<div class="room-container skeleton-border mt-4" [attr.data-testid]="'availability-skeleton-2'">
    <div class="row">
        <div class="col-12">
            <p-skeleton width="100%" height="200px" />
        </div>
        <div class="col-12">
            <div class="room-data">
                <p-skeleton height="3rem" width="100%" class="mb-2" />
                <p-skeleton height="4rem" class="mb-2" />

                <!-- amenities -->
                <!-- <div class="d-flex mb-3 gap-3">
                    <p-skeleton size="5rem" />
                    <p-skeleton size="5rem" />
                    <p-skeleton size="5rem" />
                </div>
                 -->

                <!--rates-->
                <p-skeleton height="3rem" class="mb-3" />
                <p-skeleton height="3rem" class="mb-3" />
            </div>
        </div>
    </div>
</div>

